import React, { useMemo } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";

// global scss for globally styles and fonts
import "./_fonts.scss";
import "./_global.scss";
import PublicRoute from "./Components/Routes/PublicRoute";

import { uniqueId } from "lodash";
import AddDriver from "Pages/AddDriver/AddDriver";
import ChangePassword from "Pages/ChangePassword/ChangePassword";
import DriverProfile from "Pages/DriverProfile/DriverProfile";
import DriversScreen from "Pages/DriversManagement/DriversScreen";
import EditProfile from "Pages/EditProfile/EditProfile";
import HistoryScreen from "Pages/HistoryManagement/HistoryScreen";
import Message from "Pages/messages";
import RouteDetailScreen from "Pages/RouteManagement/RouteDetailScreen";
import RouteScreen from "Pages/RouteManagement/RouteScreen";
import RouteTracking from "Pages/RouteTracking/RouteTracking";
import { ProtectedLayout } from "./Components/Layouts/ProtectedLayout";
import ProtectedRoute from "./Components/Routes/ProtectedRoute";
import { WEB_ROUTES } from "./constants";
import Account from "./Pages/Account/index";
import CreateRoute from "./Pages/CreateRoute/createRoute";
import Dashboard from "./Pages/Dashboard/Dashboard";
import EditRoute from "./Pages/EditRoute/EditRoute";

const App: React.FC = () => {
  // todo: menu

  const ROUTES = useMemo(() => {
    return [
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.ACCOUNT}
        element={
          <PublicRoute>
            <Account />
          </PublicRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.CREATE_ROUTE}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <CreateRoute />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.EDIT_ROUTE()}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <EditRoute />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.HOME}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Dashboard />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.ROUTES}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <RouteScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.ROUTE_DETAIL(":id")}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <RouteDetailScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.DRIVERS}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <DriversScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.DRIVER_PROFILE(":id")}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <DriverProfile />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.CHAT}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <Message />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.HISTORY}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <HistoryScreen />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.ROUTE_TRACKING()}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <RouteTracking />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.EDIT_PROFILE}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <EditProfile />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.CHANGE_PASSWORD}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <ChangePassword />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
      <Route
        key={uniqueId("prefix")}
        path={WEB_ROUTES.ADD_DRIVERS}
        element={
          <ProtectedRoute>
            <ProtectedLayout isSearchBar={false}>
              <AddDriver />
            </ProtectedLayout>
          </ProtectedRoute>
        }
      />,
    ];
  }, []);

  return (
    <Router>
      <Routes>
        {ROUTES.map((item) => item)}
        <Route path={"*"} element={<Navigate to={WEB_ROUTES.ACCOUNT} />} />
      </Routes>
    </Router>
  );
};

export default App;
